import { useState, type CSSProperties } from 'react';
import { workspaceTableClass } from '@/components/workspace/WorkspaceSection';
import { cn } from '@/utils/cn';

/**
 * Default PRODUCT track: 24rem, not title length.
 * Header and body both get this so auto table layout cannot grow with the name.
 * After the user resizes, colgroup widths take over (see index.css).
 */
export const WORKSPACE_PRODUCT_IDENTITY_COL_CLASS =
  'app-table-identity-cell app-table-product-identity-cell min-w-0 overflow-hidden';

function ProductThumb({ src }: { src?: string | null }) {
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src) && !failed;
  return (
    <div className="app-table-identity-thumb" aria-hidden={!showImage}>
      {showImage ? <img src={src!} alt="" onError={() => setFailed(true)} /> : null}
    </div>
  );
}

export function WorkspaceProductIdentityCell({
  productName,
  asin,
  imageUrl,
  className,
  style,
}: {
  productName?: string | null;
  asin?: string | null;
  imageUrl?: string | null;
  className?: string;
  style?: CSSProperties;
}) {
  const name = (productName || asin || '').trim();
  const asinLabel = (asin || '').trim();
  const showAsin = Boolean(asinLabel && asinLabel !== name);
  return (
    <td
      style={style}
      className={cn(
        workspaceTableClass.td,
        WORKSPACE_PRODUCT_IDENTITY_COL_CLASS,
        className,
        'app-table-cell-wrap whitespace-normal font-medium text-foreground'
      )}
    >
      <div className="app-table-identity">
        <ProductThumb src={imageUrl} />
        <div className="app-table-identity-copy">
          <div className="app-table-identity-title" title={name || undefined}>
            {name || '—'}
          </div>
          {showAsin ? (
            <div className="app-table-identity-asin truncate text-[10px] text-foreground-muted">{asinLabel}</div>
          ) : null}
        </div>
      </div>
    </td>
  );
}
